module.exports = __webpack_public_path__ + "img/icon-close.322513b7.svg";